"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[726],{

/***/ 5726:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(6042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(9396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(9534);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(1664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(1163);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/popover/popover.js + 1 modules
var popover = __webpack_require__(9860);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 3 modules
var transition = __webpack_require__(1355);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/ChevronDownIcon.js
var ChevronDownIcon = __webpack_require__(4819);
// EXTERNAL MODULE: ./node_modules/@heroicons/react/20/solid/ChevronRightIcon.js
var ChevronRightIcon = __webpack_require__(7992);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
// EXTERNAL MODULE: ./lib/global-context.js
var global_context = __webpack_require__(5439);
;// CONCATENATED MODULE: ./components/navbar-mobile.jsx









// eslint-disable-next-line react/display-name
var MenuLink = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var href = props.href, children = props.children, rest = (0,_object_without_properties/* default */.Z)(props, [
        "href",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref
        }, rest), {
            children: children
        }))
    });
});
function classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
function NavbarMobile() {
    var state = (0,global_context/* useGlobalContext */.bN)().state;
    var global = state;
    var panels = global.navigation.panels;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        id: "mobile-nav",
        className: "flex flex-grow justify-end lg:hidden",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover */.J, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                    className: "navbar-menu",
                    title: "Navigation",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {}),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {})
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Overlay */.J.Overlay, {
                    className: "fixed inset-0 bg-black opacity-60"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                    className: "z-50 w-full absolute transition-all transform mx-auto overflow-hidden inset-x-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "small-nav",
                        className: "relative flex flex-row sm:flex-col flex-wrap justify-start p-8 m-4 shadow-lg rounded-xl bg-white",
                        children: [
                            panels.map(function(p) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col px-4  ".concat(p.sections.length ? "pb-8" : "pb-2", " basis-full sm:basis-1/2"),
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                                            className: "text-sm text-trust-900 font-bold uppercase",
                                            children: [
                                                p.sections.length == 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                                                    as: MenuLink,
                                                    href: p.link.link,
                                                    children: p.link.label
                                                }),
                                                p.sections.length > 0 && p.link.label
                                            ]
                                        }),
                                        p.sections.length > 0 && p.sections.map(function(s) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    s.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                        className: "text-xs text-maturity font-bold uppercase pt-6",
                                                        children: s.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                        role: "list",
                                                        children: s.links.map(function(item) {
                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                className: "flow-root",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                                                                    as: MenuLink,
                                                                    href: item.link,
                                                                    className: " flex items-center text-medium text-default hover:text-trust-500 transition duration-150 ease-in-out py-1",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                        className: "ml-0",
                                                                        children: item.label
                                                                    })
                                                                })
                                                            }, item.id.toString());
                                                        })
                                                    })
                                                ]
                                            }, s.id);
                                        })
                                    ]
                                }, p.id);
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "flex border-t border-maturity-50 flex-col mt-4 sm:border-none flex-grow",
                                children: global.secondaryNavigation.map(function(nav) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex basis-full pt-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                                            as: MenuLink,
                                            href: nav.link,
                                            className: "px-4 py-2 text-trust opacity-75 text-sm uppercase",
                                            children: nav.label
                                        }, nav.id)
                                    }, "secnav-".concat(nav.id));
                                })
                            })
                        ]
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/photo.jsx
var photo = __webpack_require__(4761);
// EXTERNAL MODULE: ./lib/i18n-context.js
var i18n_context = __webpack_require__(7713);
;// CONCATENATED MODULE: ./components/language-choice.jsx










// eslint-disable-next-line react/display-name
var language_choice_MenuLink = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var href = props.href, locale = props.locale, children = props.children, rest = (0,_object_without_properties/* default */.Z)(props, [
        "href",
        "locale",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        locale: locale,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref
        }, rest), {
            children: children
        }))
    });
});
function LanguageChoice() {
    var state = (0,global_context/* useGlobalContext */.bN)().state;
    var router = (0,next_router.useRouter)();
    var i18n = (0,i18n_context/* useI18nContext */.C)();
    var global = state;
    var globalLanguage = global.languages.find(function(l) {
        return l.code === router.locale;
    });
    var menu = i18n.languages.data.map(function(lg) {
        if (i18n.originalSlug && i18n.originalSlug === "home") {
            lg.attributes.slug = "/";
        }
        var globalLg = global.languages.find(function(l) {
            return l.code === lg.attributes.locale;
        });
        return {
            id: lg.attributes.id,
            name: globalLg ? globalLg.name : lg.attributes.locale,
            locale: lg.attributes.locale,
            slug: lg.attributes.slug
        };
    });
    if (menu.length <= 1) {
        return "";
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover */.J, {
        className: "relative",
        children: [
            !menu.length && /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                className: "p-2 text-trust opacity-75 text-xs uppercase bg-trust-500 rounded-lg disabled",
                children: globalLanguage.name
            }),
            menu.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                        className: "p-2 text-white opacity-75 text-xs uppercase bg-trust-500 rounded-lg",
                        children: globalLanguage.name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Panel */.J.Panel, {
                        className: "absolute z-10 p-2 bg-white rounded-lg right-0 px-4",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "flex flex-col",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                children: menu.map(function(link) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                                        as: language_choice_MenuLink,
                                        href: link.slug,
                                        locale: link.locale,
                                        className: "py-2 capitalize ui-active:bg-blue-500 ui-active:text-white ui-not-active:bg-white ui-not-active:text-black",
                                        children: link.name
                                    }, "language-".concat(link.id));
                                })
                            })
                        })
                    })
                ]
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/navbar.jsx















// eslint-disable-next-line react/display-name
var navbar_MenuLink = /*#__PURE__*/ (0,react.forwardRef)(function(props, ref) {
    var href = props.href, children = props.children, rest = (0,_object_without_properties/* default */.Z)(props, [
        "href",
        "children"
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
        href: href,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref
        }, rest), {
            children: children
        }))
    });
});
function navbar_classNames() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
function Navbar() {
    var state = (0,global_context/* useGlobalContext */.bN)().state;
    var router = (0,next_router.useRouter)();
    var global = state;
    var panels = global.navigation.panels;
    var ref = (0,react.useState)(false), scrolled = ref[0], setScrolled = ref[1];
    var ref1 = (0,react.useState)(0), lastScrollTop = ref1[0], setLastScrollTop = ref1[1];
    var ref2 = (0,react.useState)(true), isTop = ref2[0], setIsTop = ref2[1];
    (0,react.useEffect)(function() {
        window.addEventListener("scroll", function() {
            var st = window.pageYOffset || document.documentElement.scrollTop;
            if (st > lastScrollTop) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
            setLastScrollTop(st < 0 ? 0 : st);
            var offset = window.scrollY;
            setIsTop(offset > 200 ? false : true);
        });
    }, [
        lastScrollTop
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed z-50 w-full top-0 ".concat(scrolled ? "scrolled" : "", " ").concat(!isTop ? "bg-black bg-opacity-80 shadow-lg" : ""),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-row justify-between max-w-screen-xl mx-auto px-4 pt-2 pb-4 sm:px-6 lg:px-2",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        className: "flex logo items-stretch justify-items-stretch w-40 lg:w-[14%] ml-0 ".concat(router.pathname === "/" ? "2xl:ml-40 3xl:ml-10 4xl:ml-0" : ""),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(photo/* default */.Z, {
                            image: global.company.logo,
                            layout: "intrinsic",
                            className: "object-cover"
                        })
                    })
                }, "el-1"),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavbarMobile, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "hidden lg:flex flex-col",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            id: "small-nav",
                            className: "relative flex flex-grow justify-end pb-1",
                            children: [
                                global.secondaryNavigation.map(function(nav) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                        href: nav.link,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                            className: "p-2 text-white hover:text-trust opacity-75 text-xs uppercase",
                                            children: nav.label
                                        })
                                    }, nav.id.toString());
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(LanguageChoice, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            id: "main-nav",
                            className: "flex flex-grow justify-end items-center",
                            children: panels.map(function(p, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover */.J, {
                                    children: function(param) {
                                        var open = param.open;
                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                            children: [
                                                p.sections.length == 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        p.style === "button" && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: p.link.link,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "group inline-flex text-white !border-2 rounded-[0.25rem] py-2 px-6 !border-white uppercase !text-xs font-semibold",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: p.link.label
                                                                })
                                                            })
                                                        }, p.link.id),
                                                        p.style === "link" && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                            href: p.link.link,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                className: "group inline-flex text-white py-2 pr-4 !text-sm",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: p.link.label
                                                                })
                                                            })
                                                        }, p.link.id)
                                                    ]
                                                }),
                                                p.sections.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                                            className: navbar_classNames(open ? "text-trust" : "text-white", "relative group inline-flex items-center rounded-md text-sm font-medium hover:text-trust focus:outline-none mr-4 py-2"),
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                    children: p.link.label
                                                                }),
                                                                p.sections.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronDownIcon, {
                                                                    className: navbar_classNames(open ? "text-trust" : "text-white", "ml-1 h-5 w-5 group-hover:text-trust opacity-50"),
                                                                    "aria-hidden": "true"
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(transition/* Transition */.u, {
                                                            as: react.Fragment,
                                                            enter: "transition ease-out duration-200",
                                                            enterFrom: "opacity-0 scale-80 -translate-y-6",
                                                            enterTo: "opacity-100 scale-100 translate-y-0",
                                                            leave: "transition ease-in duration-150",
                                                            leaveFrom: "opacity-100 scale-100 translate-y-0",
                                                            leaveTo: "opacity-0 scale-60 -translate-y-4",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Panel */.J.Panel, {
                                                                className: " z-10 transition-all transform mx-auto shadow-lg mt-2 rounded-[0.25rem] overflow-hidden ".concat(p.suggestions.length > 0 ? "max-w-screen-xl absolute w-[96%] inset-x-0 mx-auto" : "absolute"),
                                                                children: [
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "absolute inset-0 flex",
                                                                        "aria-hidden": "true",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "bg-white ".concat(p.suggestions.length > 0 ? "w-1/2" : "w-full")
                                                                            }),
                                                                            p.suggestions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "w-1/2 bg-gray-50"
                                                                            })
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "relative mx-auto grid grid-cols-1 ".concat(p.suggestions.length > 0 ? "lg:grid-cols-2" : ""),
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("nav", {
                                                                                className: " ".concat(p.suggestions.length > 0 ? "menuWithSuggestions" : "standalone"),
                                                                                "aria-labelledby": "solutions-heading",
                                                                                children: [
                                                                                    p.link.label && /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                                                                        id: "solutions-heading",
                                                                                        className: "sr-only",
                                                                                        children: [
                                                                                            p.link.label,
                                                                                            " menu"
                                                                                        ]
                                                                                    }),
                                                                                    p.sections.map(function(s) {
                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            children: [
                                                                                                s.title && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                                    className: "text-xs text-trust-900 font-bold uppercase pb-2",
                                                                                                    children: s.title
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                                                    role: "list",
                                                                                                    children: s.links.map(function(item) {
                                                                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                                                                            className: "flow-root",
                                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                                                                                                                as: navbar_MenuLink,
                                                                                                                href: item.link,
                                                                                                                className: " flex items-center text-medium text-default hover:text-trust-500 transition duration-150 ease-in-out",
                                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                    className: "ml-0",
                                                                                                                    children: item.label
                                                                                                                })
                                                                                                            })
                                                                                                        }, item.id.toString());
                                                                                                    })
                                                                                                })
                                                                                            ]
                                                                                        }, s.id.toString());
                                                                                    }),
                                                                                    p.bottomLinks.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        className: "bottomLinks",
                                                                                        children: p.bottomLinks.map(function(btlinks) {
                                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                                                                                                as: navbar_MenuLink,
                                                                                                href: btlinks.link,
                                                                                                className: "flex items-center text-medium text-trust underline hover:text-default hover:no-underline transition duration-150 ease-in-out",
                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                    className: "ml-0",
                                                                                                    children: btlinks.label
                                                                                                })
                                                                                            }, "btmLinks-".concat(p.id, "-").concat(btlinks.id));
                                                                                        })
                                                                                    })
                                                                                ]
                                                                            }),
                                                                            p.suggestions.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "bg-gray-50 px-8 py-8 lg:py-12 xl:pr-12",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                                                        role: "list",
                                                                                        className: "flex flex-row",
                                                                                        children: p.suggestions.map(function(sg) {
                                                                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                                                className: "flow-root",
                                                                                                children: [
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                                        className: "flex-shrink-0 sm:block",
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                className: "h-32 w-64 mr-2 relative",
                                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(popover/* Popover.Button */.J.Button, {
                                                                                                                    as: navbar_MenuLink,
                                                                                                                    href: sg.link.link,
                                                                                                                    className: "flex",
                                                                                                                    target: sg.link.target,
                                                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                                                        className: "rounded-md object-cover",
                                                                                                                        src: sg.image.data.attributes.formats.thumbnail.url,
                                                                                                                        alt: "",
                                                                                                                        layout: "fill"
                                                                                                                    })
                                                                                                                })
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                                                className: "min-w-0 flex-1 pt-1 pb-4",
                                                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                                                                    className: "truncate text-base font-semibold normal-case",
                                                                                                                    children: sg.title
                                                                                                                })
                                                                                                            })
                                                                                                        ]
                                                                                                    }),
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(popover/* Popover.Button */.J.Button, {
                                                                                                        as: navbar_MenuLink,
                                                                                                        href: sg.link.link,
                                                                                                        className: "cursor-pointer text-action hover:text-action-900 uppercase text-xs font-semibold",
                                                                                                        target: sg.link.target,
                                                                                                        children: [
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ChevronRightIcon, {
                                                                                                                className: "m-0 p-0 h-6 w-6 inline group-hover:text-action-900",
                                                                                                                "aria-hidden": "true"
                                                                                                            }),
                                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                                children: sg.link.label
                                                                                                            })
                                                                                                        ]
                                                                                                    })
                                                                                                ]
                                                                                            }, sg.id);
                                                                                        })
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        });
                                    }
                                }, p.id.toString());
                            })
                        })
                    ]
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(9815);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(7568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(655);
// EXTERNAL MODULE: ./node_modules/react-google-recaptcha-v3/dist/react-google-recaptcha-v3.esm.js
var react_google_recaptcha_v3_esm = __webpack_require__(259);
;// CONCATENATED MODULE: ./components/newsletter-signup-v2.jsx





function NewsletterSignup() {
    var executeRecaptcha = (0,react_google_recaptcha_v3_esm/* useGoogleReCaptcha */.xX)().executeRecaptcha;
    var ref = (0,react.useState)(false), messageSent = ref[0], setMessageSent = ref[1];
    var ref1 = (0,react.useState)(""), errorMessage = ref1[0], setErrorMessage = ref1[1];
    var ref2 = (0,react.useState)(false), pending = ref2[0], setPending = ref2[1];
    var handleSubmit = (0,react.useCallback)(function() {
        var _ref = (0,_async_to_generator/* default */.Z)(function(event) {
            var captchaAvailable, data, gReCaptchaToken, _tmp, scoreResponse, scoreResult, response, result, e;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        event.preventDefault();
                        setPending(true);
                        captchaAvailable = executeRecaptcha;
                        data = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            11,
                            ,
                            12
                        ]);
                        if (!captchaAvailable) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            executeRecaptcha("newsletter")
                        ];
                    case 2:
                        _tmp = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        _tmp = null;
                        _state.label = 4;
                    case 4:
                        gReCaptchaToken = _tmp;
                        if (!gReCaptchaToken) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            fetch("/api/captcha", {
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                method: "post",
                                body: JSON.stringify({
                                    token: gReCaptchaToken
                                })
                            })
                        ];
                    case 5:
                        scoreResponse = _state.sent();
                        return [
                            4,
                            scoreResponse.json()
                        ];
                    case 6:
                        scoreResult = _state.sent();
                        data.score = scoreResult.score;
                        // console.log('score', data.score);
                        if (data.score < 0.5) {
                            setErrorMessage("Robot verification failed! Please try again to restart the verification process. This is a security measure to prevent automated spam and ensure a better user experience");
                            setMessageSent(false);
                            setPending(false);
                            return [
                                2
                            ];
                        }
                        return [
                            3,
                            8
                        ];
                    case 7:
                        data.score = -1;
                        _state.label = 8;
                    case 8:
                        Array.from(event.target.elements).forEach(function(el) {
                            if (el.name) {
                                if (el.name.includes("[]")) {
                                    if (el.checked) {
                                        var newName = el.name.slice(0, -2);
                                        if (!data[newName]) {
                                            data[newName] = [];
                                        }
                                        data[newName].push(el.value);
                                    }
                                } else {
                                    data[el.name] = el.value;
                                }
                            }
                        });
                        return [
                            4,
                            fetch("https://europe-west1-arka-robot.cloudfunctions.net/newsletter-signup", {
                                headers: {
                                    "Content-Type": "application/json"
                                },
                                method: "POST",
                                body: JSON.stringify(data)
                            })
                        ];
                    case 9:
                        response = _state.sent();
                        return [
                            4,
                            response.json()
                        ];
                    case 10:
                        result = _state.sent();
                        if (response.status !== 200) {
                            setErrorMessage(result.error);
                            setMessageSent(false);
                        } else {
                            setErrorMessage("");
                            setMessageSent(true);
                        }
                        setPending(false);
                        return [
                            3,
                            12
                        ];
                    case 11:
                        e = _state.sent();
                        console.log(e);
                        setErrorMessage(e.message);
                        setMessageSent(false);
                        setPending(false);
                        return [
                            3,
                            12
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        });
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        executeRecaptcha
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "w-full",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "flex flex-col md:flex-row gap-4 justify-start px-0 lg:px-20",
            children: [
                messageSent && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex flex-col w-full justify-center items-center py-8 lg:py-20 px-8 lg:px-0 text-center",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                className: "text-3xl lg:text-4xl font-semibold text-trust-500 pb-4",
                                children: "Please confirm your email address"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "pb-4 text-white",
                                children: "Thank you for subscribing to our newsletter! We're thrilled to have you on board."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "pb-4 text-white",
                                children: "To complete your subscription, please confirm your email address by clicking the confirmation link we just sent to your inbox. If you have any questions, please feel free to reach out to us."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "pb-4 text-white",
                                children: "We look forward to keeping you updated with our latest news and updates!"
                            })
                        ]
                    })
                }),
                !messageSent && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col basis-1 lg:basis-1/2 py-8 px-8 lg:px-0 items-left",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-3xl lg:text-5xl font-bold text-white pb-4",
                                    children: "Sign up to our Newsletter"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "flex justify-start items-left",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "flaticon-right-arrow text-2xl text-white mt-1"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "p-2 text-white",
                                                    children: "Stay tuned to ARKA's News & Insights"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "flex justify-start items-left",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "flaticon-right-arrow text-2xl text-white mt-1"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "p-2 text-white",
                                                    children: "Great articles on industrial automation and parcel lockers"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            className: "flex justify-start items-left",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "flaticon-right-arrow text-2xl text-white mt-1"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "p-2 text-white",
                                                    children: "Get access to exclusive news about innovation"
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col basis-1 lg:basis-1/2 lg:-my-8 px-8 py-10 rounded-[0.25rem] relative text-white text-center items-center justify-center",
                            children: [
                                pending && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: "Please wait ..."
                                }),
                                !pending && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                                        onSubmit: handleSubmit,
                                        className: "space-y-4 md:space-y-8 items-center text-left w-full",
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "text",
                                                    name: "fullname",
                                                    className: "shadow-sm text-white bg-white bg-opacity-10 border rounded-[0.25rem] placeholder:uppercase placeholder:text-xs placeholder:font-semibold focus:ring-primary-500 focus:border-primary-500 block w-full p-3 border-white border-opacity-20",
                                                    placeholder: "Your name"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                                    type: "email",
                                                    name: "email",
                                                    required: true,
                                                    className: "shadow-sm text-white bg-white bg-opacity-10 border rounded-[0.25rem] placeholder:uppercase placeholder:text-xs placeholder:font-semibold focus:ring-primary-500 focus:border-primary-500 block w-full p-3 border-white border-opacity-20",
                                                    placeholder: "Your email*"
                                                })
                                            }),
                                            errorMessage !== "" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "flex bg-red-700 rounded-xl text-white font-semibold p-4",
                                                children: errorMessage
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                id: "submit-form",
                                                type: "submit",
                                                className: "btn btn-md bg-white bg-opacity-50 text-white w-full",
                                                children: "Subscribe"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
}
/* harmony default export */ var newsletter_signup_v2 = (NewsletterSignup);

;// CONCATENATED MODULE: ./components/footer-v2.jsx








function Footer(param) {
    var className = param.className;
    var ref = (0,global_context/* useGlobalContext */.bN)(), state = ref.state, dispatch = ref.dispatch;
    var router = (0,next_router.useRouter)();
    var global = state;
    var links = (0,_to_consumable_array/* default */.Z)(global.navigation.panels.filter(function(p) {
        return p.sections.length == 0;
    }).map(function(p) {
        return p.link;
    })).concat((0,_to_consumable_array/* default */.Z)(global.footerLinks));
    var sections = global.navigation.panels.filter(function(p) {
        return p.sections.length > 0;
    });
    var toggleCookieSettings = function() {
        dispatch({
            type: "TOGGLE_CONSENT",
            payload: true
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("footer", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "relative",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative bg-footer",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container pt-[4rem] pb-8 px-10 xl:px-2",
                    children: [
                        router.query.slug !== "contact" && router.query.slug !== "get-a-quote" && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "bg-white bg-opacity-5 border-b mb-4 border-white border-opacity-20 w-full relative flex py-8",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_google_recaptcha_v3_esm/* GoogleReCaptchaProvider */.pm, {
                                reCaptchaKey: "6Ld9odIjAAAAAJkiHOsNv-L532Hfg2eOgM8L3RN6",
                                language: "en",
                                scriptProps: {
                                    async: false,
                                    defer: false,
                                    appendTo: "head"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(newsletter_signup_v2, {})
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "flex flex-col md:flex-row text-white",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col pr-10 pt-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-semibold text-sm pb-4",
                                            children: "FOLLOW US:"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "icons",
                                            children: [
                                                global.company.facebook && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: global.company.facebook,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        rel: "noreferrer",
                                                        target: "_blank",
                                                        title: "Follow us on Facebook",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "flaticon-facebook mr-3 text-3xl opacity-50 hover:opacity-100 transition duration-300"
                                                        })
                                                    })
                                                }),
                                                global.company.instagram && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: global.company.instagram,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        rel: "noreferrer",
                                                        target: "_blank",
                                                        title: "Follow us on Instagram",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "flaticon-instagram mr-3 text-3xl opacity-50 hover:opacity-100 transition duration-300"
                                                        })
                                                    })
                                                }),
                                                global.company.youtube && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: global.company.youtube,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        rel: "noreferrer",
                                                        target: "_blank",
                                                        title: "Follow us on YouTube",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "flaticon-youtube mr-3 text-3xl opacity-50 hover:opacity-100 transition duration-300"
                                                        })
                                                    })
                                                }),
                                                global.company.linkedIn && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: global.company.linkedIn,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        rel: "noreferrer",
                                                        target: "_blank",
                                                        title: "Follow us on Linked-In",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "flaticon-linkedin mr-3 text-3xl opacity-50 hover:opacity-100 transition duration-300"
                                                        })
                                                    })
                                                }),
                                                global.company.twitter && /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                    href: global.company.twitter,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                        rel: "noreferrer",
                                                        target: "_blank",
                                                        title: "Follow us on Twitter",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                            className: "flaticon-twitter mr-3 text-3xl opacity-50 hover:opacity-100 transition duration-300"
                                                        })
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-row flex-wrap pt-10 md:pt-8",
                                    children: [
                                        sections.map(function(p) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col basis-full sm:basis-1/2 xl:basis-auto pr-4 pb-4",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "text-sm pb-0 font-semibold",
                                                        children: p.link.label
                                                    }),
                                                    p.sections.map(function(s) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                            className: "flex flex-col",
                                                            children: s.links.map(function(item) {
                                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                    href: item.link,
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                                        className: "py-1 text-sm text-white opacity-50 hover:opacity-100 hover:text-trust-200 transition duration-150 ease-in-out",
                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                            className: "ml-0",
                                                                            children: item.label
                                                                        })
                                                                    })
                                                                }, item.id.toString());
                                                            })
                                                        }, "footer-section-".concat(p.id, "-").concat(s.id));
                                                    })
                                                ]
                                            }, "section-panel-".concat(p.id));
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "flex flex-col xl:basis-auto pr-4 pb-4",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "text-sm pb-0 font-semibold",
                                                    children: "Links"
                                                }),
                                                links.map(function(p) {
                                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: p.link,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "flex text-sm pb-2 opacity-50 hover:opacity-100 hover:text-trust-200",
                                                            children: p.label
                                                        })
                                                    }, "section-panel-".concat(p.id));
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                                                    type: "button",
                                                    onClick: function() {
                                                        return toggleCookieSettings();
                                                    },
                                                    className: "flex text-sm pb-2 opacity-50 hover:opacity-100 hover:text-trust-200",
                                                    children: "Cookie Settings"
                                                })
                                            ]
                                        }, "no-section-panels")
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex flex-col text-left text-sm items-start mt-10 xl:mt-0 md:text-right md:items-end flex-grow pt-8",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: "/",
                                            className: "logo w-1/5",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "relative h-10 w-[8.5rem]",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                    src: global.company.logo.data.attributes.url,
                                                    alt: "",
                                                    className: "w-full h-10 object-cover",
                                                    width: 150,
                                                    height: 40
                                                })
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "font-semibold text-sm pt-4",
                                            children: "Address"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "text-sm opacity-50",
                                            dangerouslySetInnerHTML: {
                                                __html: global.company.address
                                            }
                                        }),
                                        global.company.contactInfo.map(function(c) {
                                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "font-semibold text-sm pt-4",
                                                        children: c.title
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "tel:".concat(c.phone),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "text-sm opacity-50 hover:opacity-100 block",
                                                            children: c.phone
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                        href: "mailto:".concat(c.email),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                            className: "text-sm opacity-50 hover:opacity-100 block",
                                                            children: c.email
                                                        })
                                                    })
                                                ]
                                            }, c.id);
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "w-full p-2 text-xs text-left text-white",
                            children: "\xa9 Copyright 2022 ARKA Smart Parcel Locker"
                        })
                    ]
                })
            })
        })
    });
}

// EXTERNAL MODULE: ./components/seo.jsx
var seo = __webpack_require__(1998);
;// CONCATENATED MODULE: ./components/layout.jsx





function Layout(param) {
    var languageData = param.languageData, footerClass = param.footerClass, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(i18n_context/* default.Provider */.Z.Provider, {
        value: languageData,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(seo/* default */.Z, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Navbar, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                children: children
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                className: footerClass
            })
        ]
    });
}


/***/ }),

/***/ 4761:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Photo; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _lib_global_context__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5439);
/* harmony import */ var _lib_media__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6017);




function Photo(param) {
    var quality = param.quality, image = param.image, layout = param.layout, priority = param.priority, objectFit = param.objectFit;
    if (!image) {
        return;
    }
    if (!quality) quality = 85;
    var _attributes = image.data.attributes, alternativeText = _attributes.alternativeText, width = _attributes.width, height = _attributes.height;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            layout === "fill" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                src: (0,_lib_media__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(image),
                objectFit: objectFit ? objectFit : "cover",
                alt: alternativeText || "",
                layout: layout,
                priority: priority,
                quality: quality,
                className: "object-fill"
            }),
            layout !== "fill" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                width: width,
                height: height,
                objectFit: objectFit ? objectFit : "contain",
                src: (0,_lib_media__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(image),
                alt: alternativeText || "",
                layout: layout,
                quality: quality,
                priority: priority
            })
        ]
    });
}


/***/ }),

/***/ 1998:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var _lib_seo_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4449);
/* harmony import */ var _lib_media__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6017);
/* harmony import */ var _lib_global_context__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(5439);






var Seo = function() {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_2__.useContext)(_lib_seo_context__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z), metaTitle = ref.metaTitle, metaDescription = ref.metaDescription, metaImage = ref.metaImage, keywords = ref.keywords, canonicalURL = ref.canonicalURL, structuredData = ref.structuredData, type = ref.type;
    var shareImage = (0,_lib_media__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(metaImage);
    var state = (0,_lib_global_context__WEBPACK_IMPORTED_MODULE_5__/* .useGlobalContext */ .bN)().state;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_1___default()), {
            children: [
                metaTitle && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                            children: metaTitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:title",
                            content: metaTitle
                        }, "og:title"),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "twitter:title",
                            content: metaTitle
                        })
                    ]
                }),
                metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "description",
                            content: metaDescription
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "twitter:description",
                            content: metaDescription
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:description",
                            content: metaDescription
                        }, "og:description")
                    ]
                }),
                shareImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            property: "og:image",
                            content: shareImage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "twitter:image",
                            content: shareImage
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                            name: "image",
                            content: shareImage
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:type",
                    content: type ? type : "website"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "keywords",
                    content: keywords
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "twitter:card",
                    content: "summary_large_image"
                }, "twitter:card"),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    property: "og:url",
                    content: canonicalURL
                }, "og:url"),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                    name: "theme-color",
                    content: "#1e77cb"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "canonical",
                    href: canonicalURL
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "icon",
                    href: "/favicon.ico"
                }),
                structuredData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                    id: "structured-data",
                    type: "application/ld+json",
                    dangerouslySetInnerHTML: {
                        __html: JSON.stringify(structuredData)
                    }
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "alternate",
                    type: "application/rss+xml",
                    title: "".concat(state.company.name, " RSS Feed"),
                    href: "/rss.xml"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "alternate",
                    type: "application/atom+xml",
                    title: "".concat(state.company.name, " ATOM Feed"),
                    href: "/atom.xml"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "alternate",
                    type: "application/feed+json",
                    title: "".concat(state.company.name, " JSON Feed"),
                    href: "/rss.json"
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Seo);


/***/ }),

/***/ 7713:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ useI18nContext; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

var I18nContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)();
function useI18nContext() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(I18nContext);
}
/* harmony default export */ __webpack_exports__["Z"] = (I18nContext);


/***/ }),

/***/ 6017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getMedia; }
/* harmony export */ });
/* harmony import */ var _api__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(4626);

function getMedia(media) {
    var url = media.data.attributes.url;
    var imageUrl = url.startsWith("/") ? (0,_api__WEBPACK_IMPORTED_MODULE_0__/* .getApiURL */ .t)(url) : url;
    return imageUrl;
}


/***/ }),

/***/ 4449:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7294);

// Store Strapi Global object in context
var SeoContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)();
/* harmony default export */ __webpack_exports__["Z"] = (SeoContext);


/***/ })

}]);